import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Checkbox.css';

class Checkbox extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const { formData, formErrors } = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    return <div className={`row ${ws_data.react_hidden && parseInt(ws_data.react_hidden) === 1 ? 'hidden' : ''}`}>
      <div className={`field field_checkbox ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>
          {Object.keys(ws_data.values).map((key) => {
            return <div key={key} className="checkbox">
              <input id={`${ws_data.fieldname}_${key}`} checked={parseInt(formData[ws_data.fieldname]) === 1} type="checkbox" value="1" onChange={(e) => parent.handle_change(e, ws_data.fieldname, {force_value: parseInt(formData[ws_data.fieldname]) === 1 ? 0 : 1})} /> 
              <label htmlFor={`${ws_data.fieldname}_${key}`} dangerouslySetInnerHTML={{__html: ws_data.values[key]}}></label>
            </div>;
          })}
          {(formErrors[ws_data.fieldname].length) ? <div className="form_error">{formErrors[ws_data.fieldname]}</div> : '' } 
      </div>
    </div>;
  }
};

export default Checkbox;
